<div class="d-flex flex-column content-modal al-center sp-center">
  <div class="d-flex sp-end w-100">
    <img src="assets/svg/Icon_close_modal.svg" mat-dialog-close width="56" alt="">
  </div>
  <div *ngIf="data.type == 'alert'">
    <img src="assets/svg/Icon_alert.svg" width="64" alt="">
  </div>
  <div *ngIf="data.type == 'confirm'">
    <img src="assets/svg/Icon_confirm_alert.svg" width="64" alt="">
  </div>
  <div>
    <span class="fw-extrabold fs-4 text-blue-2">{{ data.title }}</span>
  </div>
  <div class="content-description w-100 m-auto text-center">
    <span class="fs-6 fw-regular text-blue-2" [innerHTML]="data.description"></span>
  </div>
  <br>
  <button mat-flat-button class="btn-action w-100" [ngClass]="data.type == 'alert' ? 'bg-pink':'bg-blue-2'" (click)="closeDialog()">
    <span class="fw-bold fs-5 text-white me-3">{{ data.textButton }}</span>
  </button>
</div>